import { ApolloError } from '@apollo/client/core';

import {
  AEGIS_DOMAIN_OPTION_KEYS,
  type AegisDocumentOption,
  type AegisOptionValue,
  type AegisOptionValues,
} from '@move-right/aegis/core/documentOptions';

import { getApolloErrorMessage } from '../../utilities/errors.util';

export const withoutOperationPrefix = (message: string) => message.replace(/^[a-zA-Z]+: /, '');

export const errorMessage = (error: unknown): string => withoutOperationPrefix(error instanceof ApolloError
  ? getApolloErrorMessage(error)
  : error instanceof Error ? error.message : String(error));

export const isEmptyOptionValue = (value: AegisOptionValue | undefined) =>
  value === undefined || value === '' || (Array.isArray(value) && value.length === 0);

export const declaredValues = (options: AegisDocumentOption[], values: AegisOptionValues): AegisOptionValues => {
  const declared: AegisOptionValues = {};
  for (const option of options) {
    if (values[option.name] !== undefined) declared[option.name] = values[option.name];
  }
  return declared;
};

export const eventsOptionSeed = (values: AegisOptionValues | undefined): AegisOptionValues => {
  const eventIds = values?.[AEGIS_DOMAIN_OPTION_KEYS.events];
  return Array.isArray(eventIds) && eventIds.length ? { [AEGIS_DOMAIN_OPTION_KEYS.events]: eventIds } : {};
};

export const missingOptions = (options: AegisDocumentOption[], values: AegisOptionValues): AegisDocumentOption[] =>
  options.filter((option) => option.required && isEmptyOptionValue(values[option.name]));

// Requirement: a cancelled event, or one with no charges, is never billed.
export const isBillableEvent = (event: { status?: string | null; charges?: unknown[] | null }) =>
  event.status !== 'cancelled' && Boolean(event.charges?.length);

export const estimateBlockedReason = (hasBillableEvent: boolean): string | undefined =>
  (hasBillableEvent
    ? undefined
    : 'This job has no events with charges. Add a charge to an event before creating an estimate.');
